export interface ILanguage {
    code: string;
    longCode: string;
    text: string;
    flag: string;
    menuLanguage: boolean;
}

const languagesCodelist: Array<ILanguage> = [
    {
        code: 'cs',
        longCode: 'cs-cz',
        flag: '/flags/cz.svg',
        text: 'Česky',
        menuLanguage: true,
    },
    {
        code: 'sk',
        longCode: 'sk-sk',
        flag: '/flags/sk.svg',
        text: 'Slovensky',
        menuLanguage: true,
    },
    {
        code: 'en',
        longCode: 'en-us',
        flag: '/flags/gb.svg',
        text: 'English',
        menuLanguage: true,
    },
    {
        code: 'de',
        longCode: 'de-de',
        flag: '/flags/de.svg',
        text: 'Deutsch',
        menuLanguage: true,
    },
    {
        code: 'uk',
        longCode: 'uk-uk',
        flag: '/flags/uk.svg',
        text: 'Українська',
        menuLanguage: true,
    },
    {
        code: 'ru',
        longCode: 'ru-ru',
        flag: '/flags/ru.svg',
        text: 'Русский',
        menuLanguage: true,
    },
    {
        code: 'fr',
        longCode: 'fr-fr',
        flag: '/flags/fr.svg',
        text: '',
        menuLanguage: false,
    },
    {
        code: 'pl',
        longCode: 'pl-pl',
        flag: '/flags/pl.svg',
        text: '',
        menuLanguage: false,
    },
    {
        code: 'it',
        longCode: 'it-it',
        flag: '/flags/it.svg',
        text: '',
        menuLanguage: false,
    },
    {
        code: 'et',
        longCode: 'et-ee',
        flag: '/flags/ee.svg',
        text: '',
        menuLanguage: false,
    },
    {
        code: 'es',
        longCode: 'es-es',
        flag: '/flags/es.svg',
        text: '',
        menuLanguage: false,
    },
];

export default languagesCodelist;
